import {
    Component,
    OnInit,
    ViewChild
} from '@angular/core';
import {
    VoiceControlService
} from '../voice-control.service';

import {
    BsModalService
} from 'ngx-bootstrap/modal';
import {
    BsModalRef
} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {setTimeout} from 'timers';


@Component({
    selector: 'app-sa-speech-button',
    templateUrl: './speech-button.component.html'
})
export class SpeechButtonComponent implements OnInit {


    @ViewChild('speechPopover') speechPopover;
    @ViewChild('helpTemplate') helpTemplate;

    public hasError = false;
    public enabled = false;
    public isToggled = false;

    modalRef: BsModalRef;

    private subs = {
        speech: null,
        help: null
    };

    constructor(
        private modalService: BsModalService,
        private voiceControlService: VoiceControlService
    ) {
        this.enabled = this.voiceControlService.state.enabled && this.voiceControlService.state.available;

        this.subs.speech = this.voiceControlService.speechEvent$.subscribe((event) => {
            this.respondTo(event)
        });

        this.subs.help = this.voiceControlService.showHelp$.subscribe((value) => {
            if (value) {
                this.openHelpModal()
            }
        })
    }

    ngOnInit(): void {
    }

    openHelpModal() {
        this.modalRef = this.modalService.show(this.helpTemplate);
    }

    toggleVoiceControl() {
        this.isToggled = !this.isToggled;

        if (!this.voiceControlService.state.started) {
            this.voiceControlService.voiceControlOn();
        } else {
            this.voiceControlService.voiceControlOff();
        }

        if (!this.isToggled) {
            setTimeout(() => {
                this.speechPopover.hide()
            }, 10)
        }
    }

    private respondTo(event) {
        if (!event) { return; }
        switch (event.type) {
            case 'start':
                this.hasError = false;
                break;
            case 'error':
                this.hasError = true;
                break;
            case 'match':
            case 'no match':
                if (this.isToggled) {
                    this.speechPopover.hide();
                }
                break
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/shared/voice-control/speech-button/speech-button.component.ts